import React from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ArrowForwardRounded } from "@mui/icons-material";
import { WEB_COLORS } from "@/lib/constants";

const LoanCard = ({ amount }) => (
  <Box
    sx={{
      borderRadius: 2,
      boxShadow: 3,
      // textAlign: "center",
      p: 2,
      backgroundColor: {
        xs: "#F6F9F9",
        md: "#FFFFFFE5",
      },
      overflowX: "auto",
      // scrollSnapType: "x mandatory",
      gap: 2,
      // pt: 2,
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    }}
  >
    <Grid
      display={"flex"}
      justifyContent={"space-between"}
      // alignItems={"center"}
    >
      <Grid item>
        <Typography
          fontWeight="700"
          color={WEB_COLORS.darkTeal}
          gutterBottom
          sx={{
            fontSize: {
              xs: 14,
              md: 28,
            },
          }}
        >
          {amount}
        </Typography>
        <Typography
          sx={{
            fontSize: {
              xs: 12,
              md: 20,
            },
          }}
          fontWeight="400"
          color="#111111"
        >
          Salary Personal Loan
        </Typography>
      </Grid>
      <Grid
        display={"flex"}
        sx={{
          alignSelf: { xs: "flex-end" },
          py: {
            xs: 0,
            md: 2.5,
          },
        }}
      >
        <Button
          sx={{
            backgroundColor: { md: "#E9FFE6", xs: "none" },
            borderRadius: "50%",
            py: {
              md: 2.5,
            },
          }}
        >
          <ArrowForwardRounded fontSize="small" />
        </Button>
      </Grid>
    </Grid>
  </Box>
);

const LoanCardCarousel = ({amounts}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      {isMobile ? (
        <Box
          sx={{
            display: "flex",
            overflowX: "auto",
            gap: 2,
            pb: 1,
            scrollSnapType: "x mandatory",
          }}
        >
          {amounts?.map((amount, index) => (
            <Box
              key={index}
              sx={{
                flex: "0 0 auto",
                scrollSnapAlign: "start",
              }}
            >
              <LoanCard amount={amount} />
            </Box>
          ))}
        </Box>
      ) : (
        <Grid container spacing={3}>
          {amounts?.map((amount, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <LoanCard amount={amount} />
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
};

export default LoanCardCarousel;
